import { mutateAdmin } from '../graphql-client';

const workflowFragment = /* GraphQL */ `
  name
  title
  steps {
    name
    title
    description
    color
    live
    key
  }
`;

export const CREATE_WORKFLOW_MUTATION = /* GraphQL */ `
  mutation ($input: TSSaveWorkflowInput!) {
    result: addWorkflow(input: $input) {
      schemaVersion
      workflow {
        ${workflowFragment}
      }
      shapes
    }
  }
`;

export const UPDATE_WORKFLOW_MUTATION = /* GraphQL */ `
  mutation ($input: TSUpdateWorkflowInput!) {
    result: updateWorkflow(input: $input) {
      schemaVersion
      workflow {
        ${workflowFragment}
      }
      shapes
    }
  }
`;

export const REMOVE_WORKFLOW_MUTATION = /* GraphQL */ `
  mutation ($input: TSDeleteWorkflowInput!) {
    result: deleteWorkflow(input: $input) {
      name
      schemaVersion
      removed
      shapes
    }
  }
`;

export const createWorkflow = mutateAdmin(CREATE_WORKFLOW_MUTATION);
export const updateWorkflow = mutateAdmin(UPDATE_WORKFLOW_MUTATION);
export const removeWorkflow = mutateAdmin(REMOVE_WORKFLOW_MUTATION);
